import {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {SnackbarProvider, useSnackbar} from 'notistack';
import {removeNotification} from "./notifications-actions";
import {Button} from "@material-ui/core";
import {useTranslation} from "react-i18next";

let displayed = [];

const Notifier = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(store => store.notifications.notifications || []);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = (id) => {
    displayed = [...displayed, id];
  };

  const removeDisplayed = (id) => {
    displayed = [...displayed.filter(key => id !== key)];
  };

  useEffect(() => {
    notifications.forEach(({ key, message, options = {}, dismissed = false }) => {
      if (dismissed) {
        // dismiss snackbar using notistack
        closeSnackbar(key);
        return;
      }

      // do nothing if snackbar is already displayed
      if (displayed.includes(key)) return;

      // display snackbar using notistack
      enqueueSnackbar(message, {
        key,
        ...options,
        onClose: (event, reason, myKey) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey);
          }
        },
        onExited: (event, myKey) => {
          // remove this snackbar from redux store
          dispatch(removeNotification(myKey));
          removeDisplayed(myKey);
        },
      });

      // keep track of snackbars that we've displayed
      storeDisplayed(key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
}

const Notifications = ({children}) => {
  const {t} = useTranslation();
  const notifierRef = useRef();

  const onClickDismiss = key => () => {
    notifierRef.current.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      ref={notifierRef}
      action={(key) => (
        <Button onClick={onClickDismiss(key)} color="inherit">
          {t('dismiss', 'Dismiss')}
        </Button>
      )}
    >
      {children}
      <Notifier/>
    </SnackbarProvider>
  );
};

export default Notifications;
